import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import { RxCross2 } from "react-icons/rx";
import ButtonCircularProgress from "./ButtonCircularProgress";

const useStyles = makeStyles(() => ({
  IconBox: {
    position: "absolute",
    right: "0",
  },
  cancelBtn: {
    position: "absolute",
    top: 0,
    right: 0,
    "&::hover": {
      background: "transparent",
    },
    "& svg": {
      color: "#fff",
      fontWeight: "700",
      fontSize: "35px",
      background: "transparent",
    },
  },
  dialougTitle: {
    "& .subTextWallet": {
      color: "#FFFFFF99",
      maxWidth: "100%",
      marginTop: "20px",
    },
  },
}));
export default function ConfirmationDialogBox({
  openModal,
  handleClose,
  heading,
  description,
  HandleConfirm,
  isLoading,
  type,
}) {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        maxWidth="sm"
        fullWidth
        className={classes.dailogOpen}
        open={openModal}
        keepMounted
        onClose={() => !isLoading && handleClose()}
      >
        <DialogTitle className="dislogTitleBox">
          <IconButton
            disabled={isLoading}
            onClick={() => handleClose()}
            className="closeButton"
          >
            <RxCross2 />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ paddingBottom: "0px" }}>
          <Box className={classes.dialougTitle} align="center">
            <div style={{ margin: 0, padding: 0, height: "50vh" }}>
              <iframe
                src={
                  "https://surveys.hotjar.com/559ac8cc-2592-4cc0-8c39-5306011c943b"
                }
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                title="Survey"
              ></iframe>
            </div>
            <Typography className="ubuntu" variant="h4">
              {heading}
            </Typography>
            <Typography
              variant="body1"
              className="subTextWallet"
              style={{ fontFamily: "'Sora', sans-serif", color: "" }}
            >
              {description}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
